import { ArrowLeft } from 'lucide-react';

type SubpageHeaderProps = {
	title: string;
	onBack: () => void;
	breadcrumb?: [string, string];
	subtitle?: string;
};

const SubpageHeader = ({
	title,
	onBack,
	breadcrumb,
	subtitle,
}: SubpageHeaderProps) => (
	<div className="flex items-center gap-4 md:gap-6">
		<button
			type="button"
			onClick={onBack}
			className="group flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-stone-100 bg-white transition-all hover:border-stone-200 hover:shadow-sm"
			aria-label="Voltar"
		>
			<ArrowLeft
				size={20}
				className="text-stone-400 group-hover:text-stone-900"
			/>
		</button>
		<div className="min-w-0 space-y-0.5">
			<h1 className="truncate text-2xl font-black tracking-tight text-stone-900">
				{title}
			</h1>
			{breadcrumb ? (
				<div className="flex items-center gap-2 text-[10px] font-black uppercase tracking-widest text-stone-300">
					<span>{breadcrumb[0]}</span>
					<span className="text-stone-200">/</span>
					<span className="text-stone-900">{breadcrumb[1]}</span>
				</div>
			) : null}
			{subtitle ? (
				<p className="text-sm text-stone-400">{subtitle}</p>
			) : null}
		</div>
	</div>
);

export { SubpageHeader };
